// server-copa adds this many minutes (an SQLite "N MINUTES" modifier) to each match's UTC start
// time, so it must be the viewer's offset from UTC: +60 in Paris, -240 in New York.
// getTimezoneOffset() has the opposite sign (-60 in Paris), hence the minus.
export const timezoneOffset = -new Date().getTimezoneOffset();

async function request(path, options = {}) {
  const response = await fetch(path, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!response.ok) {
    throw new Error("HTTP status " + response.status);
  }
  return response;
}

async function requestJson(path) {
  const response = await request(path, { method: "GET" });
  const text = await response.text();
  return text ? JSON.parse(text) : [];
}

// server-copa matches the key against Country || LeagueCode ("usamls"), so the area comes first.
export function getMatches({ areaInfo, leagueInfo }) {
  return requestJson(`/serverapi/getMatches/${encodeURIComponent(areaInfo + leagueInfo)}/${timezoneOffset}`);
}

export function getInitialMatches({ dateInfo }) {
  return requestJson(`/serverapi/getInitialMatches/${dateInfo}/${timezoneOffset}`);
}

export function getCalculations({ HomeTeamCode, AwayTeamCode, MatchDate }) {
  return requestJson(`/serverapi/getCalculations/${HomeTeamCode}${AwayTeamCode}${MatchDate}`);
}

export function getLeagues() {
  return requestJson(`/serverapi/getLeagues`);
}

export function postUserPred(data) {
  return request(`/serverapi/postUserPred`, { method: "POST", body: JSON.stringify(data), cache: "no-cache" });
}

export function getUserPicks(userCookie) {
  return requestJson(`/serverapi/getUserPicks/${userCookie}/${timezoneOffset}`);
}

export function deleteUserPicks(userCookie, data) {
  return request(`/serverapi/deleteUserPicks/${userCookie}`,
    { method: "POST", body: JSON.stringify(data), cache: "no-cache" });
}
